import * as yup from 'yup'

declare module 'yup' {
  interface Schema<TType, TContext, TDefault, TFlags> {
    catchDefault(defaultValue: any): this
  }
}

yup.addMethod(yup.Schema, 'catchDefault', function (defaultValue) {
  return this.transform((value) => {
    try {
      return this.validateSync(value)
    } catch {
      return defaultValue
    }
  })
})

// Export the extended yup instance
export default yup
